<template>
    <span :class="{ '-error': error }">
        <img
            :class="{ '-hidden': !fullLoaded, '-loaded': fullLoaded }"
            :style="`object-fit: ${fit}`"
            @load="fullLoaded = true"
            :src="imageUrl"
            @error="error = true"
            onerror="this.src='/placeholder.png';"
        />
        <img
            class="placeholder-image"
            :class="{ '-loaded': thumbLoaded, '-hidden': fullLoaded }"
            @load="thumbLoaded = true"
            @error="error = true"
            :src="placeholderUrl"
            onerror="this.src='/placeholder.png';"
        />
    </span>
</template>
<script>
export default {
    props: {
        fit: {
            String,
            default: 'contain'
        },
        size: {
            String,
            default: ''
        },
        url: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            fullLoaded: false,
            thumbLoaded: false,
            error: false
        }
    },
    computed: {
        placeholderIcon() {
            return
        },
        imageSize() {
            switch (this.size) {
                case 'medium':
                    return '.720px.jpeg'
                case 'small':
                    return '.480px.jpeg'
                case 'thumb':
                    return '.24px.jpeg'
                default:
                    return '.jpeg'
            }
        },
        placeholderUrl() {
            return this.migratedUrl.replace('.jpeg', '.24px.jpeg')
        },
        imageUrl() {
            return this.migratedUrl.replace('.jpeg', this.imageSize)
        },
        migratedUrl() {
            return this.$Utils.handleMigratedAssetsToJPEG(this.url)
        }
    }
}
</script>
<style lang="scss" scoped>
span {
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
}
img {
    height: 100%;
    width: 100%;
    opacity: 0;
    transition: $ease;

    &.-loaded {
        opacity: 1;
    }
    &.-hidden {
        display: none;
    }

    &.placeholder-image {
        filter: blur(1px);
    }
}
</style>
